import { Api } from "api";
import { TaskFilters } from "types/task";
import { FileDetails } from "types/file";

export const getMyTasks = async (payload: TaskFilters) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/get_task_requests_for_me/`, payload_hash);
  return res.data;
};

export const getOtherTasks = async (payload: TaskFilters) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/get_task_requests_for_others/`, payload_hash);
  return res.data;
};

export const getMyCalendarTasks = async (payload: TaskFilters) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/get_task_requests_for_me_table/`, payload_hash);
  return res.data;
};

export const getOtherCalendarTasks = async (payload: TaskFilters) => {
  const hash = localStorage.getItem("hash");
  const payload_hash = {
    ...payload,
    hash_pw: hash,
  };
  const res = await Api.post(`/get_task_requests_for_others_table/`, payload_hash);
  return res.data;
};

export const getTaskById = async (taskId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_task_request_data_by_id/?hash_pw=${hash}&task_request_id=${taskId}`);
  return res.data;
};

export const setTaskStatus = async (taskId: number, status: number) => {
  const hash = localStorage.getItem("hash");
  const url = `/set_task_request_status_by_id/?hash_pw=${hash}&task_request_id=${taskId}&status=${status}`;
  const res = await Api.post(url);
  return res.data;
};

export const deleteTask = async (taskId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.delete(`/delete_task/${taskId}?hash_pw=${hash}`);
  return res.data;
};

export const createTask = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/create_task/?hash_pw=${hash}`, payload);
  return res.data;
};

export const uploadTaskFiles = async (taskId: number, payload: FormData) => {
  const hash = localStorage.getItem("hash");
  payload.append("hash_pw", hash || "");
  const res = await Api.post(`/upload_task_files/${taskId}`, payload);
  return res.data;
};

export const getTaskFileNames = async (taskId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_task_file_names/${taskId}?hash_pw=${hash}`);
  return res.data;
};

export const getTaskFileLink = async (taskId: number, file: FileDetails) => {
  const hash = localStorage.getItem("hash");
  const payload = {
    ...file,
    hash_pw: hash,
  };
  const url = `download_task_file/${taskId}`;
  const res = await Api.post(url, payload, { responseType: "blob" });
  return res;
};

export const getCommentsForTask = async (taskId: number) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_task_comments_by_id/?hash_pw=${hash}&task_request_id=${taskId}`);
  return res.data;
};

export const addCommentToTask = async (taskId: number, logs: string) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/add_comment_to_task_request/?hash_pw=${hash}&task_request_id=${taskId}&logs=${logs}`);
  return res.data;
};
